import { EArchivedListActionTypes, IArchivedListRequest, TArchivedListPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Запрос за списком архивных чатов
 */
export const setArchivedListPending = actionGenerator<EArchivedListActionTypes.SetPending, IArchivedListRequest>(
  EArchivedListActionTypes.SetPending,
);

/**
 * Установить список архивных чатов
 */
export const setArchivedListSucceed = actionGenerator<EArchivedListActionTypes.SetSucceed, TArchivedListPayload>(
  EArchivedListActionTypes.SetSucceed,
);

/**
 * Установить ошибку запроса списка архивных чатов
 */
export const setArchivedListFailed = actionGenerator<EArchivedListActionTypes.SetFailed, void>(
  EArchivedListActionTypes.SetFailed,
);
